import { render, staticRenderFns } from "./PaymentBatchTemplatesView.vue?vue&type=template&id=021239b2&scoped=true&"
import script from "./PaymentBatchTemplatesView.vue?vue&type=script&lang=js&"
export * from "./PaymentBatchTemplatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021239b2",
  null
  
)

export default component.exports